import {
    UPDATE_CONFIG,
} from '../../actionTypes';

export const updateConfig = (json) => {
    return {
        type: UPDATE_CONFIG,
        payload: json
    };
}


// WEBPACK FOOTER //
// ./src/services/config/actions.js